import React from 'react';
import { createPortal } from 'react-dom';
import { Tooltip, Paper, Box } from '@mui/material';
import { useMap, useMapEvents } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
import { Badge } from '@mui/material';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useState, useEffect, useMemo, useRef } from 'react';
import { setModal } from '../../../store/reducers/helpersReducer';
import L from 'leaflet';
import { $authHost } from '../../../http';
    
// Memoized color functions
const getColor = (percent) => {
    if (percent < 30) return "#cc0000";
    if (percent < 50) return "#cc6600";
    if (percent < 70) return "#cc9900";
    if (percent < 90) return "#4da6ff";
    return "#4dff4d";
};

const lightenColor = (hex, percent = 0.5) => {
    const num = parseInt(hex.replace("#", ""), 16);
    const r = Math.min(255, Math.round((num >> 16) * (1 - percent) + 50 * percent));
    const g = Math.min(255, Math.round(((num >> 8) & 0x00ff) * (1 - percent) + 50 * percent));
    const b = Math.min(255, Math.round((num & 0x0000ff) * (1 - percent) + 50 * percent));
    return `rgb(${r},${g},${b})`;
};



const StatisticControlButton = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [percent, setPercent] = useState(0);
    const buttonRef = useRef(null);
    const mounted = useSelector(state => state.state.mounted)
    const electricity = useSelector(state => state.state.electricity)
    const filter = useSelector(state => state.state.filter)
    const dispatch = useDispatch()
    const buttonPosition = useMemo(() => {
        const buttonRect = buttonRef.current?.getBoundingClientRect();
        return buttonRect ? {
            top: buttonRect.top,
            left: buttonRect.left,
            right: buttonRect.right,
            bottom: buttonRect.bottom,
            width: buttonRect.width,
            height: buttonRect.height
        } : null;
    }, [buttonRef.current]);
    
    useEffect(() => {
        const tpFilter = filter.tp
        let pillars = electricity.pillars.filter(p => p.stage === '4')
        if (tpFilter) {
            pillars = pillars.filter(p => !tpFilter.find(f => f === parseInt(p.tp_id)))
        }
        const pillarsCount = pillars.length;
        // const mountedCount = mounted.pillars.length;
        const mountedCount = pillars.filter(p => mounted.pillars?.find(m => m.fid === p.fid))?.length || 0
        
        setPercent(Math.round((mountedCount / pillarsCount) * 100) || 0);
    }, [electricity.pillars, mounted.pillars, filter]);

    // useEffect(() => {
    //     const fetchStats = async () => {
    //         const tpFilter = filter.tp
    //         let pillars = electricity.pillars.filter(p => p.stage === '4')
    //         if (tpFilter) {
    //             pillars = pillars.filter(p => !tpFilter.find(f => f === parseInt(p.tp_id)))
    //         }
            
    //         if (pillars.length === 0) {
    //             setPercent(0);
    //             return;
    //         }

    //         // Получаем массив fid опор
    //         const fids = pillars.map(p => p.fid);

    //         try {
    //             const response = await $authHost.post('/apig/execution/stats', {
    //                 fids: fids,
    //                 type: 'pillars'
    //             });

    //             if (response.data?.success && response.data?.data) {
    //                 const percentage = response.data.data.percentage || 0;
    //                 setPercent(Math.round(percentage));
    //             } else {
    //                 setPercent(0);
    //             }
    //         } catch (error) {
    //             console.error('Ошибка при получении статистики:', error);
    //             setPercent(0);
    //         }
    //     };

    //     // Вызываем сразу при монтировании и изменении зависимостей
    //     fetchStats();

    //     // Устанавливаем интервал для обновления каждые 5 минут
    //     const intervalId = setInterval(() => {
    //         fetchStats();
    //     }, 5 * 60 * 1000); // 5 минут = 300000 миллисекунд

    //     // Очищаем интервал при размонтировании или изменении зависимостей
    //     return () => {
    //         clearInterval(intervalId);
    //     };
    // }, [electricity.pillars, filter]);

    useMapEvents({
        'modal:open': (e) => {
            if (e.modalType !== 'statistic') {
                setIsOpen(false)
            }
        },
        'modal:close': () => {
            setIsOpen(false)
        }
    })

    const handleOpenToggle = (newState) => {
        setIsOpen(newState)
        if (newState) {
            dispatch(setModal({modalType: 'statistic', modalProps: { buttonPosition }}))
        } else {
            dispatch(setModal(null))
        }
    }

    useEffect(() => {
        if (buttonRef.current) {
            L.DomEvent.disableClickPropagation(buttonRef.current)
            L.DomEvent.disableScrollPropagation(buttonRef.current)
        }
    }, [buttonRef.current])

    return createPortal(
        <Box sx={{ zIndex: 1202, display: 'flex', order: 1, pointerEvents: 'auto' }}>
            <Tooltip title="Статистика" placement="top" arrow>
                <Paper
                    ref={buttonRef}
                    elevation={3}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: window.innerWidth < 768 ? 26 : 34,
                        height: window.innerWidth < 768 ? 26 : 34,
                        // m: '10px 10px 5px 5px',
                        opacity: 0.9,
                        bgcolor: 'rgb(40, 40, 40)',
                        boxShadow: isOpen ? '0 0 3px 3px rgb(0, 174, 255)' : '0px 2px 6px grey',
                        color: 'purple',
                        cursor: 'pointer',
                        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                        '&:hover': {
                            bgcolor: 'rgb(50, 50, 50)',
                            transform: 'scale(1.1)',
                        },
                        // zoom: window.innerWidth < 768 ? 0.8 : 1
                    }}
                    onClick={() => handleOpenToggle(!isOpen)}
                >
                    <Box sx={{ position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CircularProgress
                            variant="determinate"
                            sx={(theme) => ({
                                color: lightenColor(getColor(percent), 0.5),
                                ...theme.applyStyles('dark', {
                                    color: lightenColor(getColor(percent), 0.5),
                                }),
                            })}
                            size={window.innerWidth < 768 ? 24 : 30}
                            thickness={6}
                            value={100}
                        />
                        <CircularProgress
                            variant="determinate"
                            sx={(theme) => ({
                                color: getColor(percent),
                                position: 'absolute',
                                [`& .${circularProgressClasses.circle}`]: {
                                    strokeLinecap: 'round',
                                },
                                ...theme.applyStyles('dark', {
                                    color: getColor(percent),
                                }),
                            })}
                            size={window.innerWidth < 768 ? 24 : 30}
                            thickness={6}
                            value={percent}
                        />
                    </Box>
                    <Box
                        sx={{
                            position: 'absolute',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography
                            variant="caption"
                            component="div"
                            sx={{ color: 'white', fontSize: window.innerWidth < 768 ? 8 : 10 }}
                        >
                            {`${Math.round(percent || 0)}%`}
                        </Typography>
                    </Box>
                </Paper>
            </Tooltip>
        </Box>

        , document.getElementById("map-controls-left-top-first-row")
    )




};

export default StatisticControlButton; 